import clsx from "clsx";
import type { ComponentProps } from "react";

import type { TextContentType } from "@features/media-card/model";

import { Author } from "@shared/ui/author";
import { Button } from "@shared/ui/button";
import { Image } from "@shared/ui/image";
import { Body, Heading } from "@shared/ui/typography";

import s from "./history-card.module.scss";

export type HistoryCardProps = ComponentProps<"div"> & {
  className?: string;
  post: TextContentType;
};

export const HistoryCard = (props: HistoryCardProps) => {
  const {
    className,
    post: { author, title, platformIcon, link },
  } = props;

  return (
    <article className={clsx(s.root, className)}>
      <div>
        <Body size="uppercase-small" className={s.subtitle}>
          истории гостей
        </Body>
        <Heading level={6} tag="h3">
          {title}
        </Heading>
      </div>
      <Author data={author} />
      {platformIcon?.url && (
        <Image
          className={s.platformIcon}
          src={platformIcon.url}
          alt={platformIcon?.alternativeText ?? "platform icon"}
        />
      )}
      <Button
        href={link}
        target="_blank"
        className={s.link}
        aria-label={title}
      />
    </article>
  );
};

HistoryCard.displayName = "HistoryCard";
